import * as ActionTypes from '../actionTypes';

export const getWalletSummary = (value, meta) => ({
  type: ActionTypes.GET_WALLET_SUMMARY,
  value,
  meta
});

export const getWalletSummarySuccess = value => ({
  type: ActionTypes.GET_WALLET_SUMMARY_SUCCESS,
  value
});

export const getWalletSummaryFailure = value => ({
  type: ActionTypes.GET_WALLET_SUMMARY_FAILURE,
  value
});

export const resetWalletTransactions = value => ({
  type: ActionTypes.RESET_WALLET_TRANSACTIONS_DATA,
  value
});

export const getWalletTransactions = value => ({
  type: ActionTypes.GET_WALLET_TRANSACTIONS,
  value
});

export const getWalletTransactionsSuccess = value => ({
  type: ActionTypes.GET_WALLET_TRANSACTIONS_SUCCESS,
  value
});

export const getWalletTransactionsFailure = value => ({
  type: ActionTypes.GET_WALLET_TRANSACTIONS_FAILURE,
  value
});

export const postWalletApply = (value, meta) => ({
  type: ActionTypes.POST_WALLET_APPLY,
  value,
  meta
});

export const postWalletApplySuccess = value => ({
  type: ActionTypes.POST_WALLET_APPLY_SUCCESS,
  value
});

export const postWalletApplyFailure = value => ({
  type: ActionTypes.POST_WALLET_APPLY_FAILURE,
  value
});

export const postWalletRemove = (value, meta) => ({
  type: ActionTypes.POST_WALLET_REMOVE,
  value,
  meta
});

export const postWalletRemoveSuccess = value => ({
  type: ActionTypes.POST_WALLET_REMOVE_SUCCESS,
  value
});

export const postWalletRemoveFailure = value => ({
  type: ActionTypes.POST_WALLET_REMOVE_FAILURE,
  value
});

export const updateWalletAmount = value => ({
  type: ActionTypes.UPDATE_WALLET_AMOUNT,
  value
});

export const updateWalletRemainingBalanceAndAppliedStatus = value => ({
  type: ActionTypes.UPDATE_WALLET_REMAINING_BALANCE_AND_APPLIED_STATUS,
  value
});
